import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TopNavBar = ({ currentPage, is_new, navigationPath }) => {
    const [currentTime, setCurrentTime] = useState(new Date());
    const navigate = useNavigate();

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const formatFullDate = (date) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get abbreviated month name (e.g. JAN)
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        // Convert hours to 12-hour format and determine AM/PM
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // Handle 0 hour (midnight)

        return `${year} ${month} ${day}, ${hours}:${minutes}:${seconds} ${ampm}`;
    };


    return (
        <div className="bg-gray-800 text-white flex justify-between items-center px-6 py-3  border-b border-primary-light sticky top-0">
            {/* Current Page Name */}
            <div className="text-xl font-bold mx-3 py-1">
                {currentPage}
            </div>

            {/* Current Time and Full Date */}
            <div className="text-sm text-white flex gap-8 justify-center align-middle">
                <span className='py-2 text-orange-400 text-nowrap hidden md:block'> {formatFullDate(currentTime)}</span>
                {is_new && navigationPath &&
                    <button
                        onClick={() => { navigate(`${navigationPath}`) }}
                        className="bg-primary text-white rounded-lg hover:bg-primary-hover px-4 py-2 text-nowrap"
                    >
                        New +
                    </button>
                }
            </div>
        </div>
    );
};

export default TopNavBar;
